// Basemap tiles shared by every Leaflet map.
// OpenStreetMap's tile server (tile.openstreetmap.org) is blocked by DNS on the
// CNHP/GBS network (resolves to 127.0.0.1), and CARTO now requires an API key,
// so we use Esri's World Street Map (no key; attribution required).
export const STREET_BASEMAP = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  attribution:
    'Tiles &copy; <a href="https://www.esri.com">Esri</a> — Esri, HERE, Garmin, &copy; OpenStreetMap contributors',
  maxNativeZoom: 19,
  maxZoom: 20
};
